import { render, staticRenderFns } from "./IconFaceSmile.vue?vue&type=template&id=4e16244e&"
import script from "./IconFaceSmile.vue?vue&type=script&lang=js&"
export * from "./IconFaceSmile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports